import { LabelTranslateInterface } from "solidify-frontend";

export const labelTranslateSolidify: LabelTranslateInterface = {};
